import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

// ! ======================== DOCUMENTS PAGE (INVOICES) ============================

// ! General operation to get all data of the user and all parts
// Get user companies data
export const getUserCompaniesData = createAsyncThunk(
  "documents/getUserCompaniesData",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/users/get_all_user_data`
      );
      console.log("getUserCompaniesData", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all parts +
export const getAllParts = createAsyncThunk(
  "documents/getAllParts",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/parts/`, {});
      console.log("getAllParts", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get parts from particular location of the warehouse +
export const getPartsByLocation = createAsyncThunk(
  "documents/getPartsByLocation",
  async (locationId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/parts/by-node?location_id=${locationId}`
      );
      console.log("getPartsByLocation", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! General list of documents
// Get all documents for Items and Services +
export const getItemsDocs = createAsyncThunk(
  "documents/getItemsDocs",
  async (period, thunkAPI) => {
    try {
      const { start_date, end_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/accounting/documents`,
        {
          params: {
            from_date: start_date,
            to_date: end_date,
          },
        }
      );
      console.log("getItemsDocs", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get all payments documents +
export const getPaymentDocs = createAsyncThunk(
  "documents/getPaymentDocs",
  async (period, thunkAPI) => {
    try {
      const { start_date, end_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/accounting/payments`,
        {
          params: {
            from_date: start_date,
            to_date: end_date,
          },
        }
      );
      console.log("getPaymentDocs", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Item detailed document by id
export const getItemDocById = createAsyncThunk(
  "documents/getItemDocById",
  async (queryParams, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { id, tag, car_id } = queryParams;
      const response = await axiosInstance.get(`/doc/get_doc_detail`, {
        params: { id, tag, car_id },
        headers: {
          // "X-Api-Key": "YA7NxysJ",
          "company-id": serviceId,
        },
      });
      console.log("getItemDocById", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);


// Get list of orders for returns and receives +
export const getOrdersList = createAsyncThunk(
  "documents/getOrdersList",
  async (payload, thunkAPI) => {
    try {
      const { from_date, to_date, filter_key } = payload;
      const response = await axiosNewApiInstance.get(
        `/api/v1/supplier-orders/`,
        {
          params: { from_date, to_date, filter_key },
        }
      );
      console.log("getOrdersList", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get document by type +
export const getDocumentsByType = createAsyncThunk(
  "documents/getDocumentsByType",
  async (queryParams, thunkAPI) => {
    try {
      const { type, from_date, to_date } = queryParams;
      const response = await axiosNewApiInstance.get(
        `/api/v1/accounting/documents/${type}`,
        {
          params: { from_date, to_date },
        }
      );
      console.log("getDocumentByType", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! REVALUATION

// Get revaluation document by Id +
export const getRevaluationDoc = createAsyncThunk(
  "documents/getRevaluationDoc",
  async (revaluation_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/revaluations/${revaluation_id}`
      );
      console.log("getRevaluationDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create revaluation doc +
export const createRevaluationDoc = createAsyncThunk(
  "documents/createRevaluationDoc",
  async (editedParts, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/revaluations/`,
        editedParts
      );
      console.log("createRevaluationDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch revaluation document +
export const patchRevaluationDoc = createAsyncThunk(
  "documents/patchRevaluationDoc",
  async (data, thunkAPI) => {
    try {
      const { revaluation_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/revaluations/${revaluation_id}`,
        items
      );
      console.log("patchRevaluationDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete revaluation document +
export const deleteRevaluationDoc = createAsyncThunk(
  "documents/deleteRevaluationDoc",
  async ({ revaluation_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/revaluations/${revaluation_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteRevaluationDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! INVENTORY

// Get inventory document by Id +
export const getInventoryDoc = createAsyncThunk(
  "documents/getInventoryDoc",
  async (inventory_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/inventories/${inventory_id}`
      );
      console.log("getInventoryDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create inventory doc +
export const createInventoryDoc = createAsyncThunk(
  "documents/createInventoryDoc",
  async (editedParts, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/inventories/`,
        editedParts
      );
      console.log("createInventoryDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch inventory document +
export const patchInventoryDoc = createAsyncThunk(
  "documents/patchInventoryDoc",
  async (data, thunkAPI) => {
    try {
      const { inventory_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/inventories/${inventory_id}`,
        items
      );
      console.log("patchInventoryDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete inventory document +
export const deleteInventoryDoc = createAsyncThunk(
  "documents/deleteInventoryDoc",
  async ({ inventory_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/inventories/${inventory_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteInventoryDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! Write-off

// Get disposal document by Id +
export const getWriteOffDoc = createAsyncThunk(
  "documents/getWriteOffDoc",
  async (write_off_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/write-offs/${write_off_id}`
      );
      console.log("getDisposalDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create write-off document +
export const createWriteOffDoc = createAsyncThunk(
  "documents/createWriteOffDoc",
  async (items, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/write-offs/`,
        items
      );
      console.log("createWriteOffDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch write-off document +
export const patchWriteOffDoc = createAsyncThunk(
  "documents/patchWriteOffDoc",
  async (data, thunkAPI) => {
    try {
      const { write_off_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/write-offs/${write_off_id}`,
        items
      );
      console.log("patchWriteOffDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete write-off document +
export const deleteWriteOffDoc = createAsyncThunk(
  "documents/deleteWriteOffDoc",
  async ({ write_off_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/write-offs/${write_off_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteWriteOffDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! TRANSFERS (GOODS)

// Get goods transfer document by Id +
export const getGoodsTransferDoc = createAsyncThunk(
  "documents/getGoodsTransferDoc",
  async (transfer_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/transfers/${transfer_id}`
      );
      console.log("getGoodsTransferDoc", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create goods transfer between two legal entities +
export const createGoodsTransfer = createAsyncThunk(
  "documents/createGoodsTransfer",
  async (goodsTransferData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/transfers/`,
        goodsTransferData
      );
      console.log("createGoodsTransfer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch goods transfer document +
export const patchGoodsTransfer = createAsyncThunk(
  "documents/patchGoodsTransfer",
  async (data, thunkAPI) => {
    try {
      const { transfer_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/transfers/${transfer_id}`,
        items
      );
      console.log("patchGoodsTransfer", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete goods transfer document +
export const deleteGoodsTransfer = createAsyncThunk(
  "documents/deleteGoodsTransfer",
  async ({ transfer_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/transfers/${transfer_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteGoodsTransfer", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! RETURNS (CASH AND GOODS)

// Get return by Id (goods return) +
export const getReturnById = createAsyncThunk(
  "documents/getReturnById",
  async (return_id, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(
        `/api/v1/returns/${return_id}`
      );
      console.log("getReturnById", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get return reasons list for goods return +
export const getReturnReasonsList = createAsyncThunk(
  "documents/getReturnReasonsList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/returns/reasons`);
      console.log("getReturnReasonsList", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create reason for return document (goods return) +
export const createReturnReason = createAsyncThunk(
  "documents/createReturnReason",
  async (returnReasonData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/returns/reasons`,
        returnReasonData
      );
      console.log("createReturnReason", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create return document (goods return) +
export const createGoodsReturn = createAsyncThunk(
  "documents/createGoodsReturn",
  async (goodsReturnData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/returns/`,
        goodsReturnData
      );
      console.log("createGoodsReturn", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch return document (goods return) +
export const patchGoodsReturn = createAsyncThunk(
  "documents/patchGoodsReturn",
  async (data, thunkAPI) => {
    try {
      const { return_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/returns/${return_id}`,
        items
      );
      console.log("patchGoodsReturn", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get list of base documents and reasons for payments returns
export const getPaymentReturnBasis = createAsyncThunk(
  "documents/getPaymentReturnBasis",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/payments/`, {
        params: payload,
      });
      console.log("getPaymentReturnBasis", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete return +
export const deleteReturn = createAsyncThunk(
  "documents/deleteReturn",
  async ({ return_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/returns/${return_id}`,
        {
          data: {
            delete_reason,
          },
        }
      );
      console.log("deleteReturn", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! RECEIVES

// Get receives list +
export const getReceivesList = createAsyncThunk(
  "documents/getReceivesList",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date, scenario } = period;
      const response = await axiosNewApiInstance.get(`/api/v1/receiveds/`, {
        params: {
          from_date,
          to_date,
          scenario,
        },
      });
      console.log("getReceivesList", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create goods receive document (goods receive) +
export const createGoodsReceive = createAsyncThunk(
  "documents/createGoodsReceive",
  async (goodsReceiveData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/receiveds/`,
        goodsReceiveData
      );
      console.log("createGoodsReceive", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch goods receive document (goods receive) +
export const patchGoodsReceive = createAsyncThunk(
  "documents/patchGoodsReceive",
  async (data, thunkAPI) => {
    try {
      const { receive_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/receiveds/${receive_id}`,
        items
      );
      console.log("patchGoodsReceive", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create goods receive from several orders
export const createMultipleReceive = createAsyncThunk(
  "documents/createMultipleReceive",
  async (receiveData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/receiveds/combine`,
        receiveData
      );
      console.log("createMultipleReceive", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch goods receive from several orders +
export const patchMultipleReceive = createAsyncThunk(
  "documents/patchMultipleReceive",
  async (data, thunkAPI) => {
    try {
      const { receive_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/receiveds/${receive_id}/combine`,
        items
      );
      console.log("patchMultipleReceive", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// !SALES

// Get sales list +
export const getSalesList = createAsyncThunk(
  "documents/getSalesList",
  async (period, thunkAPI) => {
    try {
      // TODO: передавати params { from_date, to_date } (period), коли бекенд їх підтримає
      const response = await axiosNewApiInstance.get(`/api/v1/sales/`);
      console.log("getSalesList", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get sale by Id +
export const getSaleById = createAsyncThunk(
  "documents/getSaleById",
  async (saleId, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.get(`/api/v1/sales/${saleId}`);
      console.log("getSaleById", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Create sales document (sales) +
export const createSalesDocument = createAsyncThunk(
  "documents/createSalesDocument",
  async (salesData, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/sales/`,
        salesData
      );
      console.log("createSalesDocument", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Patch sales document (sales) +
export const patchSalesDocument = createAsyncThunk(
  "documents/patchSalesDocument",
  async (data, thunkAPI) => {
    try {
      const { sale_id, items } = data;

      const response = await axiosNewApiInstance.patch(
        `/api/v1/sales/${sale_id}`,
        items
      );
      console.log("patchSalesDocument", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Delete sales document (sales) +
export const deleteSalesDocument = createAsyncThunk(
  "documents/deleteSalesDocument",
  async ({ sale_id, delete_reason }, thunkAPI) => {
    try {
      const response = await axiosNewApiInstance.delete(
        `/api/v1/sales/${sale_id}`,
        { data: { delete_reason } }
      );
      console.log("deleteSalesDocument", response.data);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
